import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import { useFormik } from 'formik';
import { useCallback, useEffect } from 'react';
import moment from 'moment';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import DatePickerInput from '../../../../lib/DatePicker';
import Form, { InputType } from '../../../../lib/Formik';
import TextInput from '../../../../lib/TextField';
import {
    checkForOnlyAlphabets,
    EIGHTEEN_YEARS_IN_MILLISECONDS,
    isAlphaNumeric,
    MAX_LENGTH_FOR_PAN,
    MAX_LENGTH_FOR_NOMINEE_NAME,
    MAX_LENGTH_FOR_GUARDIAN_NAME,
    MAX_LENGTH_FOR_ADDRESS,
    minDateForCalender,
    _minDateForCalender,
    panRegex,
} from '../../../../utils/constants';
import { getNameIndex } from '../CorrectionFolios/correction-folios-selection';
import { NOMINEEINFO, validationSchemaNominee } from './update-nominee-edit';
const { dashboard, common } = en;

function AddNominee(props: any) {
    const { formik } = props;
    const thisYear = new Date().getFullYear();

    const resetFieldError = (fieldName: string) => {
        const { [fieldName]: excldeKey, ...rest } = formik.errors;
        formik.setErrors(rest);
    };

    return (
        <>
            <div className="edit-add-nominee">
                <h3>
                    {' '}
                    <img src="/images/family-icon.svg" alt="icon" />
                    {getNameIndex(props.index)} {dashboard.UpdateNominee.nomineeText}
                </h3>
                <a onClick={formik.handleSubmit} className="save-nominee">
                    {dashboard.UpdateNominee.save}
                </a>
                {/* <a onClick={() => formik.resetForm()} className="clear-nominee">
                    {dashboard.UpdateNominee.clear}
                </a> */}
                <a
                    onClick={() => props.cancelFormSubmission(props.index - 1, formik.values.id)}
                    className="clear-nominee"
                >
                    {dashboard.UpdateNominee.cancel}
                </a>
                <div className="edit-add-nominee-inner">
                    <CustomRadio
                        title={dashboard.UpdateNominee.relation}
                        name={'relation'}
                        selectedValue={formik.values.relation}
                        list={props.relations}
                        handleRadioChange={(value: string) => {
                            resetFieldError('relation');
                            props.handleNomineeChange('relation', value, props.index - 1);
                        }}
                        key={formik.values.relation}
                        error={!!formik.errors.relation}
                        helperText={formik.errors.relation}
                        extraClass={'nominee-relation-radio'}
                    />
                    <div className="nominee-fields">
                        <div className="nominee-fields-single">
                            <TextInput
                                label="Name"
                                variant="outlined"
                                value={formik.values.name}
                                name={'name'}
                                onChange={(e) => {
                                    resetFieldError('name');
                                    checkForOnlyAlphabets(e.target.value)
                                        ? props.handleNomineeChange(
                                              'name',
                                              e.target.value,
                                              props.index - 1,
                                          )
                                        : null;
                                }}
                                error={!!formik.errors.name}
                                helperText={formik.errors.name}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <div className="nominee-fields-single">
                                <DatePickerInput
                                    id={'date-picker-dialog'}
                                    label={'Date of birth'}
                                    value={formik.values.dob}
                                    onChange={(date) => {
                                        resetFieldError('dob');
                                        props.handleNomineeChange('dob', date, props.index - 1);
                                    }}
                                    minDate={_minDateForCalender()}
                                    error={!!formik.errors.dob}
                                    helperText={formik.errors.dob}
                                />
                            </div>
                            <div className="nominee-fields-single nominee-fields-share">
                                <TextInput
                                    label="%(share)"
                                    variant="outlined"
                                    value={formik.values.share}
                                    name={'share'}
                                    onChange={(e) => {
                                        resetFieldError('share');
                                        Number(e.target.value) <= 100
                                            ? props.handleNomineeChange(
                                                  'share',
                                                  e.target.value,
                                                  props.index - 1,
                                              )
                                            : null;
                                    }}
                                    error={!!formik.errors.share}
                                    helperText={formik.errors.share}
                                />
                            </div>
                        </div>
                        <div className="nominee-fields-single">
                            <CustomRadio
                                title="Gender"
                                name={'gender'}
                                selectedValue={formik.values.gender}
                                handleRadioChange={(value: any) => {
                                    resetFieldError('gender');
                                    props.handleNomineeChange('gender', value, props.index - 1);
                                }}
                                list={[
                                    {
                                        label: 'Male',
                                        value: 'male',
                                    },
                                    {
                                        label: 'Female',
                                        value: 'female',
                                    },
                                    {
                                        label: 'Others',
                                        value: 'others',
                                    },
                                ]}
                                key={formik.values.gender}
                                error={!!formik.errors.gender}
                                helperText={formik.errors.gender}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.pan}
                                variant="outlined"
                                name={'pan'}
                                value={formik.values.pan}
                                onChange={(e) => {
                                    resetFieldError('pan');
                                    isAlphaNumeric(e.target.value) &&
                                    e.target.value.length <= MAX_LENGTH_FOR_PAN
                                        ? props.handleNomineeChange(
                                              'pan',
                                              e.target.value.toUpperCase(),
                                              props.index - 1,
                                          )
                                        : null;
                                }}
                                error={!!formik.errors.pan}
                                helperText={formik.errors.pan}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.address1}
                                variant="outlined"
                                name={'address1'}
                                value={formik.values.address1}
                                onChange={(e) => {
                                    resetFieldError('address1');
                                    if (isAlphaNumeric(e.target.value)) {
                                        props.handleNomineeChange(
                                            'address1',
                                            e.target.value,
                                            props.index - 1,
                                        );
                                    }
                                }}
                                error={!!formik.errors.address1}
                                helperText={formik.errors.address1}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.address2}
                                variant="outlined"
                                name={'address2'}
                                value={formik.values.address2}
                                onChange={(e) => {
                                    resetFieldError('address2');
                                    if (isAlphaNumeric(e.target.value)) {
                                        props.handleNomineeChange(
                                            'address2',
                                            e.target.value,
                                            props.index - 1,
                                        );
                                    }
                                }}
                                error={!!formik.errors.address2}
                                helperText={formik.errors.address2}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.pin}
                                variant="outlined"
                                name={'pincode'}
                                value={formik.values.pincode}
                                onChange={(e) => {
                                    resetFieldError('pincode');
                                    (/^\d+$/.test(e.target.value) || !e.target.value) &&
                                    e.target.value.length < 7
                                        ? props.handleNomineeChange(
                                              'pincode',
                                              e.target.value,
                                              props.index - 1,
                                          )
                                        : null;
                                }}
                                error={formik.errors.pincode ? true : false}
                                helperText={formik.errors.pincode}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.city}
                                variant="outlined"
                                value={formik.values.city}
                                name={'city'}
                                onChange={(e) => {
                                    resetFieldError('city');
                                    if (!checkForOnlyAlphabets(e.target.value)) return;
                                    props.handleNomineeChange(
                                        'city',
                                        e.target.value,
                                        props.index - 1,
                                    );
                                }}
                                error={!!formik.errors.city}
                                helperText={formik.errors.city}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <TextInput
                                label={dashboard.UpdateNominee.nomineeFields.state}
                                variant="outlined"
                                value={formik.values.state}
                                onChange={(e) => {
                                    resetFieldError('state');
                                    if (
                                        !checkForOnlyAlphabets(e.target.value) ||
                                        e.target.value.length > 20
                                    )
                                        return;
                                    props.handleNomineeChange(
                                        'state',
                                        e.target.value,
                                        props.index - 1,
                                    );
                                }}
                                name={'state'}
                                error={!!formik.errors.state}
                                helperText={formik.errors.state}
                            />
                        </div>
                        <div className="nominee-fields-single">
                            <div className="nct-select">
                                <FormControl variant="filled" error={!!formik.errors.country}>
                                    <Select
                                        labelId="portfolio-sortby-label"
                                        id="portfolio-sortby"
                                        name={'country'}
                                        value={formik.values.country || 'Country (optional)'}
                                        onChange={(e) => {
                                            resetFieldError('country');
                                            props.handleNomineeChange(
                                                'country',
                                                e.target.value,
                                                props.index - 1,
                                            );
                                        }}
                                    >
                                        <MenuItem
                                            value={dashboard.UpdateNominee.nomineeFields.country}
                                        >
                                            {dashboard.UpdateNominee.nomineeFields.country}
                                        </MenuItem>
                                        <MenuItem value="India">India</MenuItem>
                                    </Select>
                                    <FormHelperText
                                        className={formik.errors.country ? 'error' : ''}
                                    >
                                        {formik.errors.country}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    {thisYear - new Date(formik.values.dob).getFullYear() < 18 && (
                        <div className="nominee-guardian-details">
                            <h4>{dashboard.UpdateNominee.guardianDetailsHeading}</h4>
                            <div className="nominee-fields">
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.name}
                                        variant="outlined"
                                        name={'guardianName'}
                                        value={formik.values.guardianName}
                                        onChange={(e) => {
                                            resetFieldError('guardianName');
                                            checkForOnlyAlphabets(e.target.value)
                                                ? props.handleNomineeChange(
                                                      'guardianName',
                                                      e.target.value,
                                                      props.index - 1,
                                                  )
                                                : null;
                                        }}
                                        error={!!formik.errors.guardianName}
                                        helperText={formik.errors.guardianName}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.pan}
                                        variant="outlined"
                                        name={'guardianPan'}
                                        value={formik.values.guardianPan}
                                        onChange={(e) => {
                                            resetFieldError('guardianPan');
                                            isAlphaNumeric(e.target.value) &&
                                            e.target.value.length <= MAX_LENGTH_FOR_PAN
                                                ? props.handleNomineeChange(
                                                      'guardianPan',
                                                      e.target.value.toUpperCase(),
                                                      props.index - 1,
                                                  )
                                                : null;
                                        }}
                                        error={!!formik.errors.guardianPan}
                                        helperText={formik.errors.guardianPan}
                                    />
                                </div>
                                <div className="nominee-fields-single">
                                    <DatePickerInput
                                        label="Date of Birth"
                                        id={'date-picker-dialog'}
                                        value={formik.values.guardianDob}
                                        name={'guardianDob'}
                                        onChange={(date) => {
                                            resetFieldError('guardianDob');
                                            props.handleNomineeChange(
                                                'guardianDob',
                                                date,
                                                props.index - 1,
                                            );
                                        }}
                                        minDate={minDateForCalender()}
                                        maxDate={moment(new Date()).format('YYYY-MM-DD')}
                                        error={!!formik.errors.guardianDob}
                                        helperText={formik.errors.guardianDob}
                                    />
                                </div>
                                {/* <div className="nominee-fields-single">
                                    <TextInput
                                        label={dashboard.UpdateNominee.nomineeFields.address1}
                                        variant="outlined"
                                        name={'guardianAddress'}
                                        value={formik.values.guardianAddress}
                                        onChange={(e) =>
                                            props.handleNomineeChange(
                                                'guardianAddress',
                                                e.target.value,
                                                props.index - 1,
                                            )
                                        }
                                    />
                                </div> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* {props.index < 3 && (
                <div className="add-nominee-btn">
                    <a onClick={props.handleAddNominee}>+ {dashboard.UpdateNominee.addNominee}</a>
                </div>
            )} */}
        </>
    );
}

export default ({ initialValues = {}, ...props }: any) => {
    const validate = (values: NOMINEEINFO) => {
        const nomineeNames = props.nominees
            .map((_ele: NOMINEEINFO, ind: number) => {
                if (ind !== props.index - 1) {
                    return _ele.name.trim().toLowerCase();
                }
            })
            .filter((name: string) => name);

        const nomineePans = props.nominees
            .map((_ele: NOMINEEINFO, ind: number) => {
                if (ind !== props.index - 1) {
                    return _ele.pan.trim().toLowerCase();
                }
            })
            .filter((pan: string) => pan);

        if (nomineeNames.includes(values.name.trim().toLowerCase())) {
            return {
                name: `Nominee name should not be same as other nominee names`,
            };
        } else if (values.name.trim().toLowerCase() === props.investorName.trim().toLowerCase()) {
            return {
                name: `Nominee name can not be investor name`,
            };
        } else if (values.name.trim().length > MAX_LENGTH_FOR_NOMINEE_NAME) {
            return {
                name: `Nominee name should be less than ${MAX_LENGTH_FOR_NOMINEE_NAME} characters`,
            };
        }
        if (values.pan === props.pan) {
            return {
                pan: `Nominee pan should not be the investor pan`,
            };
        } else if (nomineePans.includes(values.pan.trim().toLowerCase())) {
            return {
                pan: `Nominee pan should not be same as other nominee pans`,
            };
        }
        if (values.address1.trim().length > MAX_LENGTH_FOR_ADDRESS) {
            return {
                address1: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
            };
        }
        if (values.address2.trim().length > MAX_LENGTH_FOR_ADDRESS) {
            return {
                address2: `Address should be less than ${MAX_LENGTH_FOR_ADDRESS} characters`,
            };
        }
        if (!values.share?.toString()) {
            return {
                share: 'Share is required',
            };
        } else if (Number(values.share) === 0) {
            return {
                share: 'Nominee share should not be 0',
            };
        }
        if (values.dob) {
            const selectedDate = new Date(values.dob);
            if (selectedDate.getTime() > new Date().getTime()) {
                return {
                    dob: 'Date of birth should not exceed current date',
                };
            }
            const thisYear = new Date().getFullYear();
            const nomineeDobYear = new Date(formik.values.dob).getFullYear();
            if (thisYear - nomineeDobYear < 18) {
                if (!values.guardianName || values.guardianName.trim().length === 0) {
                    return {
                        guardianName: `Guardian name is required`,
                    };
                } else if (values.guardianName.trim().length > MAX_LENGTH_FOR_GUARDIAN_NAME) {
                    return {
                        guardianName: `Guardian name should be less than ${MAX_LENGTH_FOR_GUARDIAN_NAME} characters`,
                    };
                } else if (values.guardianName.toLowerCase() === values.name.toLowerCase()) {
                    return {
                        guardianName: `Nominee name and Guardian name should not be same`,
                    };
                }
                //if (!values.guardianPan || values.guardianPan.trim().length === 0) {
                //return {
                //guardianPan: `Guardian PAN is required`,
                //};
                //}
                else if (values.guardianPan && !panRegex.test(values.guardianPan)) {
                    return {
                        guardianPan: 'Please enter individual pan number',
                    };
                }
                if (
                    values.guardianPan &&
                    (values.guardianPan === values.pan || values.guardianPan === props.pan)
                ) {
                    return {
                        guardianPan:
                            values.pan === values.guardianPan
                                ? `Guardian pan should not same as Nominee pan`
                                : `Guardian pan should not same as Investor pan`,
                    };
                }
            }
        }

        // if (values.guardianDob) {
        //     const selectedDate = new Date(values.guardianDob);
        //     if (new Date().getTime() - selectedDate.getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS) {
        //         return {
        //             guardianDob: 'Guardian of the Nominee should be major',
        //         };
        //     }
        //     if (selectedDate < new Date(minDateForCalender())) {
        //         return {
        //             guardianDob: common.errors.dob.ageLessThanHundred,
        //         };
        //     }
        // }
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: () => {
            props.saveNominee('isEditable', false, props.index - 1);
        },
        onReset: () => {
            props.handleResetForm(props.index - 1);
        },
        validationSchema: validationSchemaNominee,
        validateOnChange: false,
        validate: validate,
    });

    const formFields: Partial<InputType>[] = [
        {
            component: AddNominee,
            extraProps: props,
        },
    ];

    useEffect(() => {
        formik.setValues(initialValues, false);
    }, [initialValues]);

    const FormLoad = useCallback(() => {
        return <Form ui={formFields} formik={formik}></Form>;
    }, [formik]);

    return FormLoad();
};
